export var SDK_NAME = 'sentry.javascript.browser';
export var SDK_VERSION = '5.22.3';
//# sourceMappingURL=version.js.map